/**
 * Pin categories for guidebook maps
 * Shared configuration for marker colors and categorization
 */

export interface PinCategory {
  value: string;
  label: string;
  color: string;
  lucideIcon: string;
}

export const PIN_CATEGORIES: PinCategory[] = [
  { value: 'restaurant', label: 'Restaurant', lucideIcon: 'Utensils', color: '#ef4444' },
  { value: 'cafe', label: 'Cafe & Coffee', lucideIcon: 'Coffee', color: '#92400e' },
  { value: 'bar', label: 'Bar & Nightlife', lucideIcon: 'Wine', color: '#7c3aed' },
  { value: 'attraction', label: 'Attraction & Culture', lucideIcon: 'Star', color: '#10b981' },
  { value: 'shopping', label: 'Shopping', lucideIcon: 'ShoppingBag', color: '#f97316' },
  { value: 'activity', label: 'Activity & Recreation', lucideIcon: 'Dumbbell', color: '#06b6d4' },
  { value: 'lodging', label: 'Lodging', lucideIcon: 'Hotel', color: '#3b82f6' },
  { value: 'transport', label: 'Transportation', lucideIcon: 'Train', color: '#6366f1' },
  { value: 'emergency', label: 'Emergency & Health', lucideIcon: 'Plus', color: '#dc2626' },
  { value: 'service', label: 'Services', lucideIcon: 'Wrench', color: '#64748b' },
  { value: 'food', label: 'Fast Food & Takeout', lucideIcon: 'UtensilsCrossed', color: '#ea580c' },
  { value: 'nature', label: 'Nature & Outdoors', lucideIcon: 'Trees', color: '#16a34a' },
  { value: 'landmark', label: 'Landmark', lucideIcon: 'Landmark', color: '#a855f7' },
  { value: 'other', label: 'Other', lucideIcon: 'MapPin', color: '#8b5cf6' },
];

/**
 * Get marker color for a pin style
 */
export function getMarkerColor(pinStyle: string): string {
  const category = PIN_CATEGORIES.find((cat) => cat.value === pinStyle);
  return category?.color || '#8b5cf6'; // Default purple
}

/**
 * Get Lucide icon name for a pin style
 */
export function getLucideIconName(pinStyle: string): string {
  const category = PIN_CATEGORIES.find((cat) => cat.value === pinStyle);
  return category?.lucideIcon || 'MapPin'; // Default pin
}
